/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Page Footer Data
 */

import { BsFillHeartFill } from 'react-icons/bs';

// Components
import ImgNextGen from '../components/ImgNextGen';

// Logo Truebond
import logoJpg from '../assets/img/logo-truebond.jpg';
import logoWebp from '../assets/img/logo-truebond.webp';

// Pdf
import pdf from '../assets/FichaProjeto.pdf';

const copyrightHtml = (
    <>&copy; {new Date().getFullYear()}<strong><span> Beecaramulo</span></strong></>
)

const creditsHtml = (
    <>Feito com <BsFillHeartFill className="heart" /> por 
        <a href="http://truebond.pt" target="_blank" rel="noreferrer">
            <ImgNextGen
                srcWebp={logoWebp}
                fallback={logoJpg}
                alt="Truebond"
            />
        </a>
    </>
)

const linksHtml = (
    <span>
        RNET 9992
        <a href="https://www.livroreclamacoes.pt" target="_blank" rel="noreferrer"> | Livro de Reclamações</a>
        <a href={pdf} target="_blank" rel="noreferrer"> | Ficha de Projeto</a>
        </span>
)

export const PAGEFOOTER = {
    credits: creditsHtml,
    copyright: copyrightHtml,
    links: linksHtml
}